































import Vue from 'vue'
import { mapMutations } from 'vuex'

interface Deal {
  id: number;
}

export default Vue.extend({
  props: {
    side: String,
  },
  data() {
    return {
      checkedRows: []
    }
  },
  computed: {
    deals() {
      return this.$store.state[this.side].deals
    },
  },
  watch: {
    checkedRows(rows) {
      const ids: number[] = []
      rows.forEach((row: Deal) => {
        ids.push(row.id)
      })
      console.log(ids)
      this.updateSelectedIds({side: this.side, selectedIds: ids})
    }
  },
  methods: {
    ...mapMutations(['updateSelectedIds'])
  },
  mounted() {
    const store = this.$store
    store.subscribe((mutation) => {
      if (mutation.type === 'setDeals') {
        this.checkedRows = []
      }
      if (mutation.type === 'moveDeals') {
        this.checkedRows = this.deals.filter(deal => {
          return this.$store.state[this.side].selectedIds.includes(deal.id)
        })
      }
    })
  }
})
